var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27,5H24V4a1,1,0,0,0-2,0V5H17V4a1,1,0,0,0-2,0V5H10V4A1,1,0,0,0,8,4V5H5A3,3,0,0,0,2,8V26a3,3,0,0,0,3,3H24a6,6,0,0,0,6-6V8A3,3,0,0,0,27,5ZM25,26.86V23h3A4,4,0,0,1,25,26.86ZM28,21H24a1,1,0,0,0-1,1v5H5a1,1,0,0,1-1-1V12H28Zm0-11H4V8A1,1,0,0,1,5,7H8V8a1,1,0,0,0,2,0V7h5V8a1,1,0,0,0,2,0V7h5V8a1,1,0,0,0,2,0V7h3a1,1,0,0,1,1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,16h2a1,1,0,0,0,0-2H15a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,16h2a1,1,0,0,0,0-2H22a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,16h2a1,1,0,0,0,0-2H8a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,20h2a1,1,0,0,0,0-2H8a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,20h2a1,1,0,0,0,0-2H15a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,20h2a1,1,0,0,0,0-2H22a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,24h2a1,1,0,0,0,0-2H15a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,24h2a1,1,0,0,0,0-2H8a1,1,0,0,0,0,2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.bfca971857985d22c55d8251662adc06.svg";
export { ForwardRef as ReactComponent };